import { useState } from 'react';
import {
	Box,
	Button,
	Divider,
	Drawer,
	DrawerBody,
	DrawerCloseButton,
	DrawerContent,
	DrawerFooter,
	DrawerHeader,
	DrawerOverlay,
	Flex,
	Icon,
	Stack,
	Text,
	useToast,
	useBreakpointValue
} from '@chakra-ui/react';
import { FiCornerDownRight, FiShoppingBag, FiPlus } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';

import { useAuth } from '../../hooks/auth';
import { useCart } from '../../hooks/cart';
import { formatPrice } from '../../utils/format';
import AlertCancelPedido from '../Finalizar/AlertCancelPedido';
import ModalItem from '../Cardapio/ModaItem';

type ProdutoData = {
	id: string;
	categoria: string;
	cod_barras: string;
	cod_pro: string;
	comiss_ind: number;
	comiss_ven: number;
	complementos: ComplementoData[];
	descricao: string;
	nome: string;
	obs: string;
	promocao: string;
	qtd: number;
	total: number;
	url_imagem: string;
	valor: number;
}
type ComplementoData = {
	codigo: number;
	grupo: number;
	nome: string;
	descricao: string;
	custo: number;
	valor: number;
	priceFormatted: string;
	qtd_maxima: number;
	qtd_gratis: number;
	qtd: number;
}
interface CartProps {
	isOpen: boolean;
	onRequestClose: (close: boolean) => void;
	// setIsOpenModalItem: (open: boolean) => void;
	// setIsAddNewItem: (add: boolean) => void;
	// setProdutoItemModal: (item: ProdutoData) => void;
}

const Cart: React.FC<CartProps> = ({
	isOpen,
	onRequestClose,
	// setIsOpenModalItem,
	// setIsAddNewItem,
	// setProdutoItemModal,
}) => {
	const isWideVersion = useBreakpointValue({
		base: false,
		lg: true,
	});

	const { user } = useAuth();
	const { cart, removeCart } = useCart();
	const history = useHistory();
	const toast = useToast();

	const [isOpenAlertCancelPedido, setIsOpenAlertCancelPedido] = useState(false);

	const [isOpenModalItem, setIsOpenModalItem] = useState(false);
	const [produtoItemModal, setProdutoItemModal] = useState<ProdutoData>({} as ProdutoData);

	function handleRemoveCart(id: string) {
		removeCart(id);

		if (!cart || !cart.items || cart.items.length === 0) {
			onRequestClose(false);

			toast({
				title: 'Carrinho.',
				description: 'Você excluiu todos os itens do carrinho!',
				status: 'info',
				duration: 5000,
				position: 'top-right',
				isClosable: true,
				containerStyle: {
					marginTop: '20'
				}
			})
		}
	}

	return (
		<>
			<Drawer
				isOpen={isOpen}
				placement="right"
				onClose={() => onRequestClose(false)}
				size="md"
				blockScrollOnMount={false}
			>
				<DrawerOverlay />

				<DrawerContent mt={["50px", "60px"]}>
					<DrawerCloseButton />

						<DrawerHeader pt="2" pb="1">
							<Flex direction="column">
								<Text fontSize="13px" fontWeight="500" color="gray.300" mb="-1">
									{cart.consumidor ? 'Consumidor' : 'Cliente'}
								</Text>
								<Text fontSize="15px" fontWeight="500" color="gray.600">
									{cart.cliente.nome ? cart.cliente.nome : 'Nenhum cliente selecionado'}
								</Text>
								<Text fontSize="13px" fontWeight="500" color="gray.500">{cart.cliente.doc}</Text>
							</Flex>
						</DrawerHeader>

						<Box px="4">
							<Divider orientation='horizontal' size="sm" />
						</Box>

					{!isWideVersion && (
						<>
							<Flex px="6" py="1" direction="column">
								<Text fontSize="13px" fontWeight="500" color="gray.300" mb="-1">Vendedor</Text>
								<Flex justify="space-between">
									<Text fontSize="15px" fontWeight="500" color="gray.600">{user.nome}</Text>
									<Text fontSize="13px" fontWeight="500" color="gray.500">{user.email}</Text>
								</Flex>
							</Flex>
							<Box px="4">
								<Divider orientation='horizontal' size="sm" />
							</Box>
						</>
					)}

						{!cart || cart.items.length === 0 ? (
							<DrawerBody>
								<Flex w="100%" h="100%" direction="column" justify="center" align="center">
									<Flex p="8" bg="gray.100" borderRadius="full">
										<Icon as={FiShoppingBag} fontSize="80" />
									</Flex>
									<Text pt="6" fontSize="24">Sua sacola está vazia!</Text>
									<Text pt="2" fontSize="20">Adicione itens em sua sacola.</Text>
								</Flex>
							</DrawerBody>
						) : (
							<DrawerBody>
								{history.location.pathname === '/sales' && (
									<Flex as="button" align="center" onClick={() => history.push('/products')}>
										<Icon as={FiPlus} color="blue.500" mr="1" />
										<Text fontSize={14} fontWeight="500" color="blue.500">Adicionar mais itens</Text>
									</Flex>
								)}

								{cart.items?.map((item) => {
									return (
										<Flex
											key={item.id}
											flexDir="column"
											py="2"
											borderBottomWidth={1}
											borderBottomColor="gray.100"
										>
											<Flex justify="space-between">
												<Text fontSize="15px">{item.qtd}x {item.nome}</Text>
												<Text fontSize="15px">{formatPrice(item.total)}</Text>
											</Flex>

											{item.complementos?.map(comp => {
												return comp.qtd > 0 && (
													<Flex key={comp.codigo} px="2">
														<Icon as={FiCornerDownRight} color="gray.300" />
														<Text fontSize="14px">{comp.qtd}x {comp.nome}</Text>
													</Flex>
												)
											})}

											<Stack spacing="2" direction="row">
												<Text
													as="button"
													color="blue.500"
													fontSize="14px"
													fontWeight="500"
													onClick={() => {
														// setIsAddNewItem(false);
														setProdutoItemModal(item);
														setIsOpenModalItem(true);
													}}
												>
													Editar
												</Text>
												<Text
													as="button"
													color="gray.500"
													fontSize="14px"
													fontWeight="500"
													onClick={() => handleRemoveCart(item.id)}
												>
													Remover
												</Text>
											</Stack>
										</Flex>
									)
								})}

								<Flex direction="column" pt="4">
									<Flex justify="space-between">
										<Text fontSize="15" fontWeight="500" color="gray.400">SubTotal</Text>
										<Text fontSize="15" fontWeight="500" color="gray.400">{formatPrice(cart.subTotal)}</Text>
									</Flex>

									<Flex justify="space-between">
										<Text fontSize="15" fontWeight="500" color="gray.400">Taxa Entrega</Text>
										<Text fontSize="15" fontWeight="500" color="gray.400">{formatPrice(cart.taxa_entrega)}</Text>
									</Flex>

									<Flex justify="space-between">
										<Text fontSize="15" fontWeight="500" color="gray.800">Total</Text>
										<Text fontSize="15" fontWeight="500" color="gray.800">{formatPrice(cart.total)}</Text>
									</Flex>
								</Flex>
							</DrawerBody>
						)}

						<DrawerFooter w="100%">
							{(cart.cliente?.id || cart.items?.length > 0) &&
							<Stack direction="row" spacing="2" w="100%">
								<Button
									w="100%"
									colorScheme='blue'
									fontSize={["12", "16"]}
									isDisabled={cart.items.length === 0}
									onClick={() => history.push('/finaly')}
								>
									Escolher pagamento
								</Button>

								<Button
									w="100%"
									colorScheme="blackAlpha"
									fontSize={["12", "16"]}
									onClick={() => setIsOpenAlertCancelPedido(true)}
								>
									Cancelar Pedido
								</Button>
							</Stack>
							}
						</DrawerFooter>
				</DrawerContent>
			</Drawer>

			<AlertCancelPedido
				isOpen={isOpenAlertCancelPedido}
				onRequestClose={setIsOpenAlertCancelPedido}
			/>

			{isOpenModalItem && (
				<ModalItem
					isOpen={isOpenModalItem}
					onRequestClose={setIsOpenModalItem}
					produto={produtoItemModal}
					incluir={false}
				/>
			)}
		</>
	)
}

export default Cart;
